import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput, FormTextarea, FormSwitch, FormSelect } from '../FormInputs';
import { NarrativeTypeChooser } from '../FormFilters/NarrativeTypeChooser/NarrativeTypeChooser';
import type { NarrativeFormData, SelectOption } from '../Forms/types';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { InlineReveal } from '../InlineReveal/InlineReveal';

interface BasicInfoGroupProps {
  form: any;
  mode?: 'add' | 'edit';
  featureFlags?: string[];
  projects?: SelectOption[];
}

export const BasicInfoGroup: React.FC<BasicInfoGroupProps> = ({ form, mode = 'add', featureFlags = [], projects = [] }) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  
  const isCaseModerationEnabled = featureFlags?.includes('case_moderation');
  const hasDescription = form.state.values.description && form.state.values.description.trim().length > 0;

  const reviewStatusOptions: SelectOption[] = [
    {
      value: 'PENDING',
      label: t('Pending'),
    },
    {
      value: 'ACCEPTED',
      label: t('Accepted'),
    },
    {
      value: 'DECLINED',
      label: t('Declined'),
    },
  ];

  return (
    <div className="form-wrapper">
      <div className="form-wrapper-header">
        <h2>{mode === 'add' ? t('Create new case') : t('Edit case')}</h2>
        <div className="form-wrapper-header-actions">
          {currentUser?.type !== 'UNDERPRIVILEGED' && (
            <>
                <FormSwitch
                  form={form}
                  name="isActive"
                  label={t('Active')}
                  className="active-case-switch"
                />
              </>
            
          )}
        </div>
      </div>

      <div className="group-card">
        <FormInput
          form={form}
          name="name"
          label={t('Name')}
          required
        />

        <InlineReveal label={t('Add description (optional)') } isOpen={hasDescription}>
          <FormTextarea
            form={form}
            name="description"
            label={t('Description')}
          />
        </InlineReveal>

        {mode === 'edit' && isCaseModerationEnabled && currentUser?.type !== 'UNDERPRIVILEGED' && (
          <div className="form-element">
            <FormSelect
              form={form}
              name="reviewStatus"
              label={t('Status')}
              placeholder={t('Status')}
              options={reviewStatusOptions}
            />
          </div>
        )}

        <form.Field
          name="currentNarrativeType"
          children={(field: any) => (
            <NarrativeTypeChooser
              currentNarrativeTypeIndex={field.state.value || 0}
              onChange={(selected) => field.handleChange(selected)}
              isEditMode={mode === 'edit'}
            />
          )}
        />

        {projects.length > 0 && (
          <div className="form-element">
            <FormSelect
              form={form}
              name="project"
              label={t('Project')}
              placeholder={t('Select project')}
              options={projects}
            />
          </div>
        )}
      </div>
    </div>
  );
};